import html2pdf from "html2pdf.js";
import * as XLSX from "xlsx";

const formatNumber = (num) => {
    if (num === null || num === undefined) return "0,00";

    return parseFloat(num).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

const formatDate = (dataStr) => {
    if (!dataStr) return "";

    const apenasData = dataStr.split(" ")[0];
    const partes = apenasData.split("-");

    if (partes.length === 3) {
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }

    return dataStr;
};

const criarElementoPdf = (dia, grupo) => {
    const elemento = document.createElement("div");

    const totalRevisado = parseFloat(dia.total_revisado) || 0;
    const totalDefeitos = parseFloat(dia.metragem_defeito) || 0;

    const percentualTotal =
        totalRevisado > 0
            ? (totalDefeitos / totalRevisado) * 100
            : 0;

    const defeitosHtml = (dia.defeitos || [])
        .map((defeito) => {
            const metragem = parseFloat(defeito.metragem) || 0;

            const percentual =
                totalRevisado > 0
                    ? (metragem / totalRevisado) * 100
                    : 0;

            return `
                <tr>
                    <td style="padding: 10px;border: 1px solid #ccc;text-align: left;">
                        ${defeito.defeito}
                    </td>

                    <td style="padding: 10px;border: 1px solid #ccc;text-align: right;">
                        ${formatNumber(metragem)} m
                    </td>

                    <td style="padding: 10px;border: 1px solid #ccc;text-align: right;">
                        ${formatNumber(percentual)}%
                    </td>
                </tr>
            `;
        })
        .join("");

    elemento.innerHTML = `
        <div style="font-family: Arial, sans-serif;padding: 30px;color: #222;">

            <h1 style="text-align: center;margin-bottom: 5px;">
                Relatório Diário de Defeitos
            </h1>

            <div style="text-align: center;margin-bottom: 30px;color: #555;">
                ${grupo.setor} - ${formatDate(dia.data)}
            </div>

            <table style="width: 100%;border-collapse: collapse;margin-bottom: 25px;">
                <tbody>

                    <tr>
                        <td style="padding: 8px;border: 1px solid #ddd;">
                            <strong>Setor</strong>
                        </td>

                        <td style="padding: 8px;border: 1px solid #ddd;">
                            ${grupo.setor}
                        </td>
                    </tr>

                    <tr>
                        <td style="padding: 8px;border: 1px solid #ddd;">
                            <strong>Data</strong>
                        </td>

                        <td style="padding: 8px; border: 1px solid #ddd;">
                            ${formatDate(dia.data)}
                        </td>
                    </tr>

                    <tr>
                        <td style="padding: 8px;border: 1px solid #ddd;">
                            <strong>Total revisado</strong>
                        </td>

                        <td style="padding: 8px;border: 1px solid #ddd;">
                            ${formatNumber(totalRevisado)} m
                        </td>
                    </tr>

                    <tr>
                        <td style="padding: 8px;border: 1px solid #ddd;">
                            <strong>Total de defeitos</strong>
                        </td>

                        <td style="padding: 8px;border: 1px solid #ddd;">
                            ${formatNumber(totalDefeitos)} m
                        </td>
                    </tr>

                    <tr>
                        <td style="padding: 8px;border: 1px solid #ddd;">
                            <strong>Percentual de defeitos</strong>
                        </td>

                        <td style="padding: 8px;border: 1px solid #ddd;">
                            ${formatNumber(percentualTotal)}%
                        </td>
                    </tr>

                    <tr>
                        <td style="padding: 8px;border: 1px solid #ddd;">
                            <strong>Meta de qualidade</strong>
                        </td>

                        <td style="padding: 8px;border: 1px solid #ddd;">
                            ${formatNumber(grupo.meta_qualidade)}%
                        </td>
                    </tr>

                </tbody>
            </table>

            <h3>
                Detalhamento dos defeitos
            </h3>

            <table style="width: 100%;border-collapse: collapse;">

                <thead>
                    <tr>

                        <th style="padding: 10px;border: 1px solid #ccc;text-align: left;">
                            Defeito
                        </th>

                        <th style="padding: 10px;border: 1px solid #ccc;text-align: right;">
                            Metragem
                        </th>

                        <th style="padding: 10px;border: 1px solid #ccc;text-align: right;">
                            Percentual
                        </th>

                    </tr>
                </thead>

                <tbody>
                    ${defeitosHtml}
                </tbody>

                <tfoot>
                    <tr>

                        <td style="padding: 10px;border: 1px solid #ccc;font-weight: bold;">
                            Total
                        </td>

                        <td style="padding: 10px;border: 1px solid #ccc;text-align: right;font-weight: bold;">
                            ${formatNumber(totalDefeitos)} m
                        </td>

                        <td style="padding: 10px;border: 1px solid #ccc;text-align: right;font-weight: bold;">
                            ${formatNumber(percentualTotal)}%
                        </td>

                    </tr>
                </tfoot>

            </table>

        </div>
    `;

    return elemento;
};

const getPdfOptions = (dia, grupo) => ({
    margin: 10,

    filename: `Relatorio_${grupo.setor}_${dia.data}.pdf`,

    image: {
        type: "jpeg",
        quality: 0.98
    },

    html2canvas: {
        scale: 2,
        useCORS: true
    },

    jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait"
    }
});

export const handlePdfDia = async (dia, grupo) => {
    const elemento = criarElementoPdf(dia, grupo);
    const options = getPdfOptions(dia, grupo);

    await html2pdf()
        .set(options)
        .from(elemento)
        .save();
};

export const imprimirPdfDia = async (dia, grupo) => {
    const elemento = criarElementoPdf(dia, grupo);
    const options = getPdfOptions(dia, grupo);

    const pdfBlob = await html2pdf()
        .set(options)
        .from(elemento)
        .outputPdf("blob");

    const pdfUrl = URL.createObjectURL(pdfBlob);

    const janela = window.open(pdfUrl, "_blank");

    if (janela) {
        janela.onload = () => {
            janela.print();
        };
    }
};

export const handleExcelDia = (dia, grupo) => {
    const totalRevisadoDia = parseFloat(dia.total_revisado) || 0;
    const totalDefeitosDia = parseFloat(dia.metragem_defeito) || 0;
    const percentualDia = totalRevisadoDia > 0 ? (totalDefeitosDia / totalRevisadoDia) : 0;
    const dataFormatada = formatDate(dia.data);

    const linhasExportacao = [];

    if (dia.defeitos && dia.defeitos.length > 0) {
        dia.defeitos.forEach((def) => {
            const metragemDef = parseFloat(def.metragem) || 0;
            const percentualDef = totalRevisadoDia > 0 ? (metragemDef / totalRevisadoDia) : 0; 

            linhasExportacao.push({
                "Setor": grupo.setor,
                "Meta de Qualidade (%)": parseFloat(grupo.meta_qualidade),
                "Data": dataFormatada,
                "Total Revisado (m)": totalRevisadoDia,
                "Total Defeito do Dia (m)": totalDefeitosDia,
                "% do Dia": (percentualDia * 100).toFixed(2),
                "Nome do Defeito": def.defeito,
                "Metragem Defeito (m)": metragemDef,
                "% do Defeito": (percentualDef * 100).toFixed(2),
            });
        });
    } else {
        linhasExportacao.push({
            "Setor": grupo.setor,
            "Meta de Qualidade (%)": parseFloat(grupo.meta_qualidade),
            "Data": dataFormatada,
            "Total Revisado (m)": totalRevisadoDia,
            "Defeito do Dia (m)": totalDefeitosDia,
            "% do Dia": (percentualDia * 100).toFixed(2),
            "Nome do Defeito": "Nenhum",
            "Metragem Defeito (m)": 0,
            "% do Defeito": 0
        });
    }

    const worksheet = XLSX.utils.json_to_sheet(linhasExportacao);
    const workbook = XLSX.utils.book_new();
    
    XLSX.utils.book_append_sheet(workbook, worksheet, "Defeitos do Dia");

    const dataFormatadaArquivo = dataFormatada.replace(/\//g, '-');
    
    XLSX.writeFile(workbook, `Defeitos_${grupo.setor}_${dataFormatadaArquivo}.xlsx`);
};